var constants = {
    async setGlobalProps(app){
        var props = app.config.globalProperties;

        props.$FORM_MODE_VIEW = "View"
        props.$FORM_MODE_CREATE = "Create"
        props.$FORM_MODE_EDIT = "Edit"
        }
}

export default constants